// extracted by mini-css-extract-plugin
export default {"shippingPrice":"ShipmentPriceInfo_shippingPrice__CDiey"};